import React from 'react';

import './icon__arrow-right.scss';

const IconArrowRight = (props) => (
    <svg {...props} className="icon__arrow-right" viewBox="0 0 580 1100">
        <path
            d="M571.021,571.021 C570.426,571.615 569.801,572.159 569.170,572.693 L50.845,1091.019 C39.198,1102.666 20.315,1102.666 8.668,1091.019 C-2.979,1079.372 -2.979,1060.489 8.668,1048.842 L507.667,549.844 L8.668,50.845 C-2.979,39.198 -2.979,20.315 8.668,8.669 C20.315,-2.979 39.198,-2.979 50.845,8.669 L569.170,526.994 C569.801,527.528 570.426,528.072 571.021,528.666 C576.866,534.512 579.776,542.181 579.753,549.843 C579.776,557.506 576.866,565.175 571.021,571.021 Z"
            fillRule="evenodd"
        />
    </svg>
);

export default IconArrowRight;
